export default __webpack_public_path__ + "static/media/820.bc088d00.png";